import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Linkedin, Mail, ArrowUp } from 'lucide-react';
import { profileData } from '../data/mock';

const Footer = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const scrollToTop = () => { window.scrollTo({ top: 0, behavior: 'smooth' }); };
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { href: '#about', label: 'About', isAnchor: true },
    { href: '#experience', label: 'Experience', isAnchor: true },
    { href: '#skills', label: 'Skills', isAnchor: true },
    { href: '#education', label: 'Education', isAnchor: true },
    { href: '/blog', label: 'Blog', isAnchor: false },
    { href: '/memories', label: 'Wall of Fame', isAnchor: false },
    { href: '/apps', label: 'Apps', isAnchor: false },
    { href: '/booking', label: 'Book Appointment', isAnchor: false },
    { href: '#contact', label: 'Contact', isAnchor: true }
  ];

  const scrollToSection = (e, href) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      if (!isHomePage) { window.location.href = '/' + href; return; }
      const element = document.querySelector(href);
      if (element) { element.scrollIntoView({ behavior: 'smooth' }); }
    }
  };

  return (
    <footer className="bg-[#faf6ee] text-[#152846] border-t border-[#e6dfd0]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="py-16 grid md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <span className="text-gold-400">Dr. Srijit</span> Nair
            </h3>
            <div className="text-[#8b94a3] leading-relaxed mb-6 space-y-1">
              <p>Chief Executive Officer at ITHR Technologies Consulting LLC.</p>
              <p>Business Head IT & ITES - (Fractional) ERAM Digital, Subsidiary of ERAM Holdings</p>
              <p className="pt-2 text-[#5c6878]">Developing innovative human capital strategies & driving business growth</p>
            </div>
            <div className="flex items-center gap-4">
              <a href={profileData.linkedin} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#fffdf8] border border-[#e6dfd0] rounded-lg flex items-center justify-center text-[#8b94a3] hover:bg-gold-400 hover:text-black hover:border-gold-400 transition-all duration-300" aria-label="LinkedIn" data-testid="footer-linkedin">
                <Linkedin size={20} strokeWidth={2.5} />
              </a>
              <a href={`mailto:${profileData.email}`} className="w-10 h-10 bg-[#fffdf8] border border-[#e6dfd0] rounded-lg flex items-center justify-center text-[#8b94a3] hover:bg-gold-400 hover:text-black hover:border-gold-400 transition-all duration-300" aria-label="Email" data-testid="footer-email">
                <Mail size={20} strokeWidth={2.5} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6 text-gold-400" style={{ fontFamily: "'Playfair Display', serif" }}>Quick Links</h4>
            <nav className="space-y-3">
              {navLinks.map((link) => (
                link.isAnchor ? (
                  <a key={link.href} href={isHomePage ? link.href : '/' + link.href} onClick={(e) => scrollToSection(e, link.href)} className="block text-[#8b94a3] hover:text-gold-400 hover:translate-x-1 transition-all duration-300">{link.label}</a>
                ) : (
                  <Link key={link.href} to={link.href} className="block text-[#8b94a3] hover:text-gold-400 hover:translate-x-1 transition-all duration-300">{link.label}</Link>
                )
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6 text-gold-400" style={{ fontFamily: "'Playfair Display', serif" }}>Get in Touch</h4>
            <div className="space-y-4">
              <a href={`mailto:${profileData.email}`} className="block text-[#8b94a3] hover:text-gold-400 transition-colors">{profileData.email}</a>
              <p className="text-[#8b94a3]">{profileData.location}</p>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-[#e6dfd0] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#aab2bf] text-sm">&copy; {currentYear} {profileData.name}. All rights reserved.</p>
          <button onClick={scrollToTop} className="flex items-center gap-2 text-[#8b94a3] hover:text-gold-400 transition-colors group" data-testid="back-to-top-btn">
            <span className="text-sm">Back to Top</span>
            <ArrowUp size={16} strokeWidth={2.5} className="group-hover:-translate-y-1 transition-transform" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
